import React from "react";

const ProgressBar = ({ progress }) => {
  return (
    <div className="progressContainer">
      <div
        className="progressBar gradientBg fw-light"
        style={{ width: `${progress}%` }}
      >
        {progress}% Completed
      </div>
    </div>
  );
};

export default ProgressBar;
